import whatsApp from 'assets/icons/WhatsApp.png'
import CheckIcon from 'assets/icons/check-circle-success.svg'
import axios from 'axios'
import CustomButton from 'components/Buttons/CustomButton'
import ComodityCardItem from 'components/CommodityCardItem'
import SvgIcon from 'components/Icon/SvgIcon'
import PMBTotalFooter from 'components/PMBTotalFooter'
import { parseNumber } from 'helpers'
import { useEffect, useState } from 'react'
import { AlertTriangle, Info, Mail } from 'react-feather'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, CardBody, CardTitle, Container, Input } from 'reactstrap'
import { apiEndpoint } from '../../../utility/Utils'
import { setNumberStep, setTotal } from '../commodityPurchaseSlice'
import ModalConfirmation from './ModalConfirmation'

const Payment = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const intl = useIntl()
  const { token, serviceProvision } = useSelector((e) => e.auth)
  const { cashPayment } = useSelector((e) => e.dashboard)
  const [paymentMethod, setPaymentMethod] = useState(null)
  const [userData, setUserData] = useState({})
  const [isNotRegis, setisNotRegis] = useState(false)
  const [saldo, setSaldo] = useState({})
  const { total } = useSelector((s) => s.comodityPurchase)
  const [isOpenModalConfirmation, setIsOpenModalConfirmation] = useState(false)
  const [isOpenModalConfirmationNonPPN, setIsOpenModalConfirmationNonPPN] =
    useState(false)
  const [isLoadingConfirmRemove, setIsLoadingConfirmRemove] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const [isRemovedCommodity, setIsRemovedCommodity] = useState(false)
  const [transactionData, setTransactionData] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const allowPayment =
    transactionData?.items?.[0]?.orderDetail?.allowPayment ||
    transactionData?.items?.[0]?.buyerDetail?.allowPayment

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const isEmail = Boolean(searchParams.get('isEmail'))
  const { type } = location.state || {}

  const setNumber = (e) => dispatch(setNumberStep(e))
  const setTotalAmount = (e) => dispatch(setTotal(e))

  const handleClickPayment = (data) => {
    setPaymentMethod(data)
  }

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true)
      if (paymentMethod === 0 || paymentMethod === 2 || paymentMethod === 3) {
        const obj = {
          totalAmount: userData?.dataComodities?.reduce(
            (sum, e) => sum + (e.totalPrice ?? 0),
            0,
          ),
          loanDays: 0,
          creditRequested: 0,
          useProofOfPayment: paymentMethod === 3,
          usePayable: paymentMethod === 2,
          item: userData?.dataComodities?.map((e) => {
            return {
              comodity: e?.comodity,
              SKU: e?.comodity?.sku ?? e?.comodity?.SKU,
              amount: e?.quantity,
              price:
                typeof e?.price === 'string'
                  ? Number(
                    e?.price?.replace(/[^\d,]/g, '')?.replace?.(/\./g, ''),
                  )
                  : e?.price,
              unit: e?.unit?.value,
              useProofOfPayment: paymentMethod === 3 ? true : false,
              usePayable: paymentMethod === 2 ? true : false
            }
          }),
        }
        const resp = await axios.post(
          `${apiEndpoint}/api/v1/bussines/transaction/calculate`,
          obj,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        if (resp.status === 200) {
          navigate('/transaksi-pembelian-pembayaran-uang-belanja-konfirmasi')

          let newUserData = {
            ...userData,
            ...resp.data,
            paymentMethod: paymentMethod,
          }

          if (paymentMethod !== 1) {
            delete newUserData.useTalangin;
            delete newUserData.talangin;
            delete newUserData.selectedTenor;
            delete newUserData.dataTenor;
            delete newUserData.maxCreditLimit;
            delete newUserData.repo;
          }

          localStorage.setItem(
            'userData',
            JSON.stringify(newUserData),
          )
        }
      } else {
        navigate('/transaksi-pembelian-pembayaran-talangin', {
          state: {
            isAgency: hasTrue,
          },
        })
      }
    } catch {
      // Error checking talangin
    } finally {
      setIsSubmitting(false)
    }
  }

  const getSaldo = async (userId) => {
    try {
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/saldo?sellerUserId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      setSaldo(data)
      const userData = JSON.parse(localStorage.getItem('userData'))
      const obj = {
        ...userData,
        ...data,
      }
      localStorage.setItem('userData', JSON.stringify(obj))
    } catch {
      // Error fetching saldo
    }
  }

  const getTransaction = async (id) => {
    try {
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/transaction?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      setTransactionData(data)
      if (data?.items?.[0]?.status === 'Menunggu Pembayaran Pembeli') {
        setisNotRegis(false)
      }
    } catch {
      // Error fetching transaction
    }
  }

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'))
    setUserData(userData)
    getSaldo(userData?.dataSeller?.userId)
    if (
      (userData?.dataSeller?.status === 'UNREGISTERED' ||
        userData?.dataSeller?.profileStatus === 'UNVERIFIED' ||
        !userData?.dataSeller?.isLogin) &&
      !userData?.alreadyReceived
    ) {
      setisNotRegis(true)
    }
    if (userData?.trxId) {
      getTransaction(userData?.trxId)
    }
    setNumber(2)
    setTotalAmount(
      userData?.dataComodities?.reduce(
        (sum, e) => sum + (e.totalPrice ?? 0),
        0,
      ),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey])

  const agencyStatuses =
    userData?.dataComodities?.map((item) => !!item?.comodity?.agencyModel) || []

  const hasTrue = agencyStatuses.includes(true)
  const hasFalse = agencyStatuses.includes(false)

  const isMixStatusAgency = hasTrue && hasFalse

  const toggleModalConfirmation = () => {
    setIsOpenModalConfirmation(false)
  }

  const toggleModalConfirmationNonPPN = () => {
    setIsOpenModalConfirmationNonPPN(false)
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleConfirmRemove = () => {
    setIsLoadingConfirmRemove(true)
    const userData = JSON.parse(localStorage.getItem('userData'))
    const newObj = {
      ...userData,
      dataComodities: isOpenModalConfirmationNonPPN
        ? userData?.dataComodities?.filter(
          (item) => item?.comodity?.agencyModel,
        )
        : userData?.dataComodities?.filter(
          (item) => !item?.comodity?.agencyModel,
        ),
    }
    const newObjComodities = {
      ...newObj,
      comodities: newObj?.dataComodities?.map((item, idx) => {
        return {
          id: idx + 1,
        }
      }),
    }
    localStorage.setItem('userData', JSON.stringify(newObjComodities))

    setTimeout(() => {
      toggleModalConfirmation()
      toggleModalConfirmationNonPPN()
      setIsLoadingConfirmRemove(false)
      if (saldo?.talangin > 0) {
        setPaymentMethod(1)
      }
      setRefreshKey((prev) => prev + 1)
    }, 2000)
  }

  const filteredDataPPN = userData?.dataComodities?.filter(
    (item) => item?.comodity?.agencyModel,
  )

  const filteredDataNonPPN = userData?.dataComodities?.filter(
    (item) => !item?.comodity?.agencyModel,
  )

  const showCashOption =
    (type === 'buyFromSell' && allowPayment?.cash === 1) ||
    (!type && (cashPayment || userData?.alreadyReceived))

  const showSellerCredit = allowPayment
    ? (type === 'buyFromSell' && allowPayment?.payable === 1) ||
    (!type && allowPayment?.payable)
    : saldo?.sellersCredit

  const showCOD = type === 'buyFromSell' && allowPayment?.cod

  return (
    <div>
      {/* MODAL CONFIRMATION REMOVE */}
      <ModalConfirmation
        isOpen={isOpenModalConfirmation}
        isOpenNonPPN={isOpenModalConfirmationNonPPN}
        toggle={() => {
          toggleModalConfirmation()
          toggleModalConfirmationNonPPN()
        }}
        onConfirm={handleConfirmRemove}
        data={
          isOpenModalConfirmationNonPPN ? filteredDataNonPPN : filteredDataPPN
        }
        isLoading={isLoadingConfirmRemove}
        isMobile={isMobile}
      />
      <Container fluid className="custom-container pb-5 mb-5">
        {isNotRegis && (
          <Card className="mb-4" data-testid="payment-seller-waiting-banner">
            <CardBody>
              <div
                style={{
                  backgroundColor: '#ECFAFF',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: '#8ABBCC',
                }}
                className=" d-flex flex-row justify-content-between align-items-center p-3 rounded mb-3 "
              >
                <div className="d-flex flex-row gap-2 align-items-center">
                  {isEmail ? (
                    <Mail size={32} color="#006386" />
                  ) : (
                    <img
                      style={{ height: '32px', width: '32px' }}
                      src={whatsApp}
                      alt="whatsapp"
                    />
                  )}
                  <span>
                    Sebelum Anda melanjutkan pembayaran, penjual harus melakukan
                    konfirmasi melalui {isEmail ? 'Email' : 'WhatsApp'} terlebih
                    dahulu.
                  </span>
                </div>
              </div>
              <p className="text-primary fw-bold">
                Menunggu konfirmasi penjual
              </p>
              <div style={{ height: '7px' }} className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: '15%' }}
                  aria-valuenow="15"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </CardBody>
          </Card>
        )}
        <Card style={{ opacity: isNotRegis ? '40%' : '' }} className="p-2 mb-5">
          <CardBody>
            <div className="mb-5">
              {isMixStatusAgency && (
                <div className="d-flex align-items-center badge-blues my-3 w-100 rounded p-2 border border-info">
                  <Info size={16} className="flex-shrink-0 me-2" />
                  <span className="text-sm">
                    Terdapat barang yang dikenakan PPN dan tidak dikenakan
                    PPN
                  </span>
                </div>
              )}

              <div className="mb-3 d-flex justify-content-between">
                <span className="fw-bold">Daftar Pembelian</span>
                {userData?.alreadyReceived && (
                  <>
                    {' '}
                    <div className="text-success-700 rounded bg-success-50 p-1">
                      {' '}
                      <small className="fw-500 mx-1">
                        <img src={CheckIcon} alt="check-icon" /> Barang sudah
                        diterima
                      </small>
                    </div>
                  </>
                )}
              </div>
              {userData?.dataComodities?.map((e, index) => {
                return (
                  <ComodityCardItem
                    key={index}
                    comodity={e?.comodity}
                    amount={e?.quantity}
                    unit={e?.unit?.value}
                    price={parseNumber(e?.price)}
                    total={e?.totalPrice}
                  />
                )
              })}
            </div>
            <div>
              <CardTitle
                style={{ fontWeight: 'bold' }}
                tag="h6"
                className="mb-3"
              >
                Pilih metode pembayaran
              </CardTitle>
              <div
                style={{
                  backgroundColor:
                    (userData?.dataSeller?.status === 'UNREGISTERED' ||
                      userData?.dataSeller?.profileStatus === 'UNVERIFIED') &&
                      userData?.alreadyReceived
                      ? '#F9FAFB'
                      : paymentMethod === 0
                        ? '#ECFAFF'
                        : '',
                  opacity:
                    (userData?.dataSeller?.status === 'UNREGISTERED' ||
                      userData?.dataSeller?.profileStatus === 'UNVERIFIED') &&
                      userData?.alreadyReceived
                      ? '50%'
                      : '',
                  cursor: 'pointer',
                }}
                className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded mb-3 ${paymentMethod === 0 ? 'border-primary' : ''
                  }`}
                onClick={() => {
                  if (!isNotRegis && total <= saldo?.wallet1) {
                    handleClickPayment(0)
                  }
                }}
                data-testid="payment-method-uang-belanja"
              >
                <div className="d-flex flex-row gap-2">
                  <SvgIcon
                    name="wallet"
                    size={30}
                    color="white"
                    withBackground={true}
                    backgroundColor="#006386"
                  />
                  <div className="d-flex flex-column">
                    <span style={{ fontWeight: 'bold' }}>Uang Belanja</span>
                    <span
                      className={total > saldo?.wallet1 ? 'text-danger' : ''}
                    >
                      {total > saldo?.wallet1 ? 'Kurang' : 'Tersedia'}: Rp
                      {intl.formatNumber(
                        total > saldo?.wallet1
                          ? total - saldo?.wallet1
                          : (saldo?.wallet1 ?? 0),
                        {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        },
                      )}
                    </span>
                  </div>
                </div>
                {total > saldo?.wallet1 ? (
                  <CustomButton
                    outline
                    color="primary"
                    size="sm"
                    onClick={() =>
                      navigate('/topup', {
                        state: { trx: true },
                      })
                    }
                    testId="payment-topup-shortcut-button"
                  >
                    Tambah Uang Belanja
                  </CustomButton>
                ) : (
                  <Input
                    type="checkbox"
                    checked={paymentMethod === 0}
                    data-testid="payment-method-uang-belanja-checkbox"
                    onChange={() => {
                      if (!isNotRegis && total <= saldo?.wallet1) {
                        handleClickPayment(0)
                      }
                    }}
                    disabled={
                      (userData?.dataSeller?.status === 'UNREGISTERED' ||
                        userData?.dataSeller?.profileStatus === 'UNVERIFIED') &&
                      userData?.alreadyReceived
                    }
                  />
                )}
              </div>
              <div
                style={{
                  backgroundColor:
                    isMixStatusAgency || !saldo?.talangin
                      ? '#F9FAFB'
                      : paymentMethod === 1
                        ? '#ECFAFF'
                        : '',
                  opacity:
                    isMixStatusAgency || !saldo?.talangin
                      ? '50% !important'
                      : '',
                  cursor: isMixStatusAgency ? 'not-allowed' : 'pointer',
                }}
                className={`border d-flex flex-column p-3 rounded mb-3 ${paymentMethod === 1 ? 'border-primary' : ''
                  }`}
                onClick={() => {
                  if (!isNotRegis && saldo?.talangin && !isMixStatusAgency) {
                    handleClickPayment(1)
                  }
                }}
                data-testid="payment-method-talangin"
              >
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <div className="d-flex flex-row gap-2">
                    {/* <img
                      style={{
                        height: '32px',
                        width: '32px',
                        opacity:
                          isMixStatusAgency || !saldo?.talangin ? '50%' : '',
                      }}
                      src={uangUsaha}
                      alt="talangin"
                    /> */}
                    <SvgIcon
                      name="card"
                      size={30}
                      color="black"
                      withBackground={true}
                      backgroundColor="#FEDF89"
                    />
                    <div
                      className="d-flex flex-column"
                      style={{
                        opacity:
                          isMixStatusAgency || !saldo?.talangin ? '50%' : '',
                      }}
                    >
                      <span style={{ fontWeight: 'bold' }}>
                        Talangin{' '}
                        <small
                          style={{ backgroundColor: '#FEDF89' }}
                          className="badge rounded-pill text-dark"
                        >
                          LEBIH HEMAT
                        </small>
                      </span>
                      <span>
                        Tersedia: Rp
                        {intl.formatNumber(saldo?.talangin ?? 0, {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                      </span>
                    </div>
                  </div>
                  <Input
                    style={{
                      opacity:
                        isMixStatusAgency || !saldo?.talangin ? '50%' : '',
                    }}
                    type="checkbox"
                    checked={paymentMethod === 1}
                    data-testid="payment-method-talangin-checkbox"
                    onChange={() => {
                      if (
                        !isNotRegis &&
                        saldo?.talangin &&
                        !isMixStatusAgency
                      ) {
                        handleClickPayment(1)
                      }
                    }}
                    disabled={!saldo?.talangin || isMixStatusAgency}
                  />
                </div>

                {isMixStatusAgency && !type && (
                  <div className="mt-3">
                    <div className="d-flex flex-column badge-warning my-3 w-100 rounded p-3 border border-warning">
                      <div className="d-flex align-items-center mb-3">
                        <AlertTriangle
                          size={16}
                          className="flex-shrink-0 me-2"
                        />
                        <div className="d-flex flex-column">
                          <span
                            style={{ fontSize: isMobile ? '12px' : '14px' }}
                          >
                            Talangin hanya untuk barang sejenis (dikenakan
                            atau tidak dikenakan PPN)
                          </span>
                          <span
                            style={{ fontSize: isMobile ? '12px' : '14px' }}
                          >
                            Untuk menggunakan Talangin, pilih salah satu yang
                            dihapus:
                          </span>
                        </div>
                      </div>
                      <div className="d-flex flex-column gap-2 d-md-flex flex-md-row gap-md-4">
                        <CustomButton
                          outline
                          block
                          color="primary"
                          onClick={() => setIsOpenModalConfirmation(true)}
                          className="mb-2 mb-md-0"
                          style={{
                            fontSize: isMobile
                              ? '12px !important'
                              : '14px !important',
                          }}
                          testId="payment-remove-ppn-button"
                        >
                          Dikenakan PPN
                        </CustomButton>
                        <CustomButton
                          outline
                          block
                          color="primary"
                          onClick={() => setIsOpenModalConfirmationNonPPN(true)}
                          style={{
                            fontSize: isMobile
                              ? '12px !important'
                              : '14px !important',
                          }}
                          testId="payment-remove-non-ppn-button"
                        >
                          Tidak dikenakan PPN
                        </CustomButton>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {showSellerCredit &&
                ('isLogin' in (userData?.dataSeller ?? {})
                  ? userData.dataSeller.isLogin
                  : true) ? (
                <div
                  style={{
                    backgroundColor: paymentMethod === 2 ? '#ECFAFF' : '',
                    cursor: 'pointer',
                  }}
                  className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded mb-3 ${paymentMethod === 2 ? 'border-primary' : ''
                    }`}
                  onClick={() => {
                    if (!isNotRegis) {
                      handleClickPayment(2)
                    }
                  }}
                  data-testid="payment-method-kredit-penjual"
                >
                  <div className="d-flex flex-row gap-2 align-items-center">
                    <SvgIcon
                      name="database"
                      size={30}
                      color="white"
                      withBackground={true}
                      backgroundColor="#039855"
                    />

                    <div className="d-flex flex-column">
                      <span style={{ fontWeight: 'bold' }}>Kredit Penjual</span>
                    </div>
                  </div>
                  <Input
                    disabled={isNotRegis}
                    type="checkbox"
                    checked={paymentMethod === 2}
                    data-testid="payment-method-kredit-penjual-checkbox"
                    onChange={() => {
                      if (!isNotRegis) {
                        handleClickPayment(2)
                      }
                    }}
                  />
                </div>
              ) : null}

              {(serviceProvision?.cod || showCOD) && (
                <div
                  style={{
                    backgroundColor: paymentMethod === 3 ? '#ECFAFF' : '',
                    cursor: 'pointer',
                  }}
                  className={`border d-flex flex-row justify-content-between align-items-center p-3 rounded mb-3 ${paymentMethod === 3 ? 'border-primary' : ''
                    }`}
                  onClick={() => {
                    handleClickPayment(3)
                  }}
                  data-testid="payment-method-cod"
                >
                  <div className="d-flex flex-row gap-2 align-items-center">
                    <SvgIcon
                      name="old-icons-hand-holding-usd"
                      size={30}
                      color="white"
                      withBackground={true}
                      backgroundColor="#7F56D9"
                    />

                    <div className="d-flex flex-column">
                      <span style={{ fontWeight: 'bold' }}>COD</span>
                    </div>
                  </div>
                  <Input
                    type="checkbox"
                    checked={paymentMethod === 3}
                    data-testid="payment-method-cod-checkbox"
                    onChange={() => {
                      handleClickPayment(3)
                    }}
                  />
                </div>
              )}
              {showCashOption && (
                <span className="text-primary-600 fw-500" data-testid="payment-cash-link">
                  Pembayaran tunai atau sudah bayar?{' '}
                  <u
                    onClick={() => {
                      if (!isNotRegis) {
                        navigate('/transaksi-pembelian-cash', {
                          state: {
                            totalAmount: userData?.dataComodities?.reduce(
                              (sum, e) => sum + e.totalPrice,
                              0,
                            ),
                            item: userData?.dataComodities?.map((e) => ({
                              comodity: e?.comodity,
                              amount: e?.quantity,
                              price: e?.price,
                              unit: e?.unit?.value,
                            })),
                          },
                        })
                      }
                    }}
                    style={{ cursor: !isNotRegis ? 'pointer' : null }}
                  >
                    Klik di sini
                  </u>
                </span>
              )}
            </div>
          </CardBody>
        </Card>
      </Container>
      <PMBTotalFooter
        total={total}
        isLoading={isSubmitting}
        isDisable={isNotRegis || paymentMethod === null || isSubmitting}
        textBtn="Lanjutkan Pembayaran"
        onSubmit={handleSubmit}
        testId="payment"
      />
    </div>
  )
}

export default Payment

// BACKUP WITH BUTTON REMOVE NON PPN
